import { PageHero } from "@/components/PageHero";
import { Reveal, MaskLinesInView } from "@/components/Reveal";
import { LuxButton } from "@/components/LuxButton";
import { IMG } from "@/data/brand";

const chapters = [
  { n: "01", title: "Our Identity", copy: "River Stone Chophouse is an Arts & Crafts inspired sanctuary in the Harbour View area of northern Suffolk — stone fireplaces, romantic booths and a spirited raw bar, welcoming discerning diners from across Hampton Roads.", image: IMG.fireplace },
  { n: "02", title: "The Steak Program", copy: "Whole primals of Hereford beef, dry-aged in house for a minimum of twenty-eight days and hand-carved to order. Depth, tenderness and character that cannot be rushed.", image: IMG.steakFlame },
  { n: "03", title: "From The Water", copy: "Oysters shucked to order, chilled towers and daily catches drawn from cold Atlantic waters — the raw bar at the heart of a coastal table.", image: IMG.oysters },
  { n: "04", title: "The Cellar & Hospitality", copy: "An award-winning list spanning old-world classics and Virginia's own vineyards, served with quiet, considered hospitality that reads the room as well as the label.", image: IMG.wineCellar },
];

const OurStoryPage = () => (
  <main data-testid="our-story-page">
    <PageHero kicker="Coastal Virginia" title={["Our Story"]} image={IMG.chefPlating} />

    <section className="bg-[#f8f5f0] py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <p className="font-serif text-3xl sm:text-4xl md:text-5xl text-[#1a1817] font-light leading-[1.3]">
            A distinctive and memorable dining experience — <span className="italic text-[#9E1F24]">artfully crafted, exceptionally served.</span>
          </p>
        </Reveal>
      </div>
    </section>

    {chapters.map((c, i) => (
      <section key={c.n} className={`py-16 md:py-24 ${i % 2 === 0 ? "bg-white" : "bg-[#f8f5f0]"}`}>
        <div className={`max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
          <Reveal className="lg:[direction:ltr]">
            <div className="overflow-hidden">
              <img src={c.image} alt={c.title} className="w-full h-[360px] md:h-[520px] object-cover" />
            </div>
          </Reveal>
          <div className="lg:[direction:ltr]">
            <Reveal>
              <span className="font-serif text-6xl text-[#C1272D]/40">{c.n}</span>
              <h2 className="font-serif text-4xl sm:text-5xl text-[#1a1817] font-light mt-3 leading-tight">
                <MaskLinesInView lines={[c.title]} />
              </h2>
              <p className="text-[#6d6661] font-light leading-relaxed mt-6 max-w-md">{c.copy}</p>
            </Reveal>
          </div>
        </div>
      </section>
    ))}

    {/* Connection + careers */}
    <section id="careers" className="bg-[#0a0908] py-24 md:py-32 grain relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <span className="text-[10px] tracking-[0.35em] uppercase text-[#c5a059]">The Family</span>
          <h2 className="font-serif text-4xl sm:text-5xl text-white font-light mt-5 leading-[1.05]">Part of Pack Brothers Hospitality</h2>
          <p className="text-white/60 font-light leading-relaxed mt-6 max-w-md">
            River Stone is a proud member of the Pack Brothers Hospitality family — a collection of distinct Virginia dining experiences that share a single, elevated standard of craft and service.
          </p>
          <div className="mt-8">
            <LuxButton to="/vision" variant="outline-light" testid="story-vision-btn">The Bigger Vision</LuxButton>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="border border-white/10 p-10">
            <h3 className="font-serif text-3xl text-white">Now Hiring</h3>
            <p className="text-white/60 font-light mt-4 leading-relaxed">
              We're building an award-winning team — hosts, servers and back of house. Experience preferred but not required; a love of hospitality essential.
            </p>
            <div className="mt-8">
              <LuxButton to="/reservations#contact" variant="gold" testid="story-careers-btn">Get in Touch</LuxButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  </main>
);

export default OurStoryPage;
